import { Box } from '@mui/material';
import { getPortfoliosTemplates } from 'lib/api/integrations/digitalSignature';
import { GetTemplatesResponse } from 'lib/api/integrations/digitalSignature';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import Table from 'lib/designSystem/Table';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DetailsDialog from './Components/DetailsDialog';

const Templates = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState<GetTemplatesResponse[]>([]);
  const [selectedTemplate, setSelectedTemplate] =
    useState<GetTemplatesResponse | null>(null);
  const [showDialog, setShowDialog] = useState(false);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const templates = await getPortfoliosTemplates(dispatch);
      setTemplates(templates);
      if (selectedTemplate && showDialog) {
        const updatedTemplate = templates.find(
          (t) => t.id === selectedTemplate.id,
        );
        if (updatedTemplate) {
          setSelectedTemplate(updatedTemplate);
        }
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickRow = (row: string) => {
    const template = templates.find((t) => t.id === row);
    if (!template) return;
    setSelectedTemplate(template);
    setShowDialog(true);
  };

  const dataHeaders = [
    { label: 'Título', key: 'title' },
    { label: 'Descripción', key: 'description' },
    { label: 'Gatilladores', key: 'triggers' },
    { label: 'Validaciones', key: 'validations' },
  ];

  useEffect(() => {
    void fetchTemplates();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <>
      <Box mt={2}>
        <Table
          dataHeaders={dataHeaders}
          data={templates}
          handleClickRow={handleClickRow}
        />
      </Box>

      <DetailsDialog
        open={showDialog}
        setOpen={setShowDialog}
        template={selectedTemplate}
        refreshTemplates={fetchTemplates}
      />
    </>
  );
};

export default Templates;
